import columnTypes from '../columnTypes.js';
import types from '../types.js';

const cloudOwnersTables = [
  {
    key: 'cloud-data-owners',
    name: 'Cloud Owners',
    [columnTypes.default.key]: [
      {
        source: 'OwnerName',
        rename: 'Owner Name',
        type: types.text,
      },
      {
        source: 'SharedObjects',
        rename: 'Shared Objects',
        type: types.number,
      },
      {
        source: 'OneDriveSharedObjects',
        rename: 'OneDrive Shared Objects',
        type: types.number,
      },
      {
        source: 'SharePointSharedSites',
        rename: 'SharePoint Shared Sites',
        type: types.number,
      },
      {
        source: 'SharePointSharedObjects',
        rename: 'SharePoint Shared Objects',
        type: types.number,
      },
      {
        source: 'TeamsSharedObjects',
        rename: 'Teams Shared Objects',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'SharedFolders',
        rename: 'Shared Folders',
        type: types.number,
      },
      {
        source: 'SharedFiles',
        rename: 'Shared Files',
        type: types.number,
      },
      {
        source: 'SharePointSharedFolders',
        rename: 'SharePoint Shared Folders',
        type: types.number,
      },
      {
        source: 'SharePointSharedFiles',
        rename: 'SharePoint Shared Files',
        type: types.number,
      },
      {
        source: 'OneDriveSharedFolders',
        rename: 'OneDrive Shared Folders',
        type: types.number,
      },
      {
        source: 'OneDriveSharedFiles',
        rename: 'OneDrive Shared Files',
        type: types.number,
      },
      {
        source: 'TeamsSharedFolders',
        rename: 'Teams Shared Folders',
        type: types.number,
      },
      {
        source: 'TeamsSharedFiles',
        rename: 'Teams Shared Files',
        type: types.number,
      },
      {
        source: 'Domain',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'Department',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'OwnerID',
        rename: 'Owner Id',
      },
    ],
  },
  {
    key: 'cloud-data-SharedFileDetail',
    name: 'Cloud data shared File details',
    [columnTypes.default.key]: [
      {
        source: 'FileName',
        rename: 'File Name',
        type: types.text,
      },
      {
        source: 'DirectUsers',
        rename: 'Direct Users',
        type: types.text,
      },
      {
        source: 'TotalGroups',
        rename: 'Total Groups',
      },
      {
        source: 'TotalUsers',
        rename: 'Total Users',
      },
      {
        source: 'OwnerName',
        rename: 'Owner Name',
        type: types.text,
      },
      {
        source: 'Domain',
        rename: 'Domain',
        type: types.text,
      },
      {
        source: 'Department',
        rename: 'Department',
        type: types.text,
      },
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'Directory',
        rename: 'Directory',
        type: types.text,
      },
      {
        source: 'Platform',
        rename: 'Platform',
        type: types.text,
      },
      {
        source: 'ExternallyShared',
        rename: 'Externally Shared',
        type: types.text,
      },
      {
        source: 'InternallyShared',
        rename: 'Internally Shared',
        type: types.text,
      },
      {
        source: 'FileExtension',
        rename: 'File Extension',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'FullAccessPath',
        rename: 'Full Access Path',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      { source: 'Id_Full_Folder_List', rename: 'Id_Full_Folder_List' },
    ],
  },
  {
    key: 'cloud-data-MostSharedFiles',
    name: 'Cloud Data MostSharedFiles',
    [columnTypes.default.key]: [
      {
        source: 'FileName',
        rename: 'Name',
        type: types.text,
      },
      {
        source: 'TotalUsers',
        rename: '# Users',
        type: types.number,
      },
      {
        source: 'TotalGroups',
        rename: '# Groups',
        type: types.number,
      },
      {
        source: 'OwnerName',
        rename: 'Owner',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [],
    [columnTypes.hidden.key]: [
      {
        source: 'FileID',
        rename: 'File Id',
      },
      {
        source: 'WebURL',
        rename: 'Web URL',
      },
    ],
  },
  {
    key: 'cloud-data-BiggestSharers',
    name: 'Cloud Data BiggestSharers',
    [columnTypes.default.key]: [
      {
        source: 'OwnerName',
        rename: 'Owner Name',
        type: types.text,
      },
      {
        source: 'SharedObjects',
        rename: '# Objects',
        type: types.number,
      },
      {
        source: 'SharedFolders',
        rename: '# Folders',
        type: types.number,
      },
      {
        source: 'SharePointSharedSites',
        rename: '# Sites',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'Domain',
        rename: 'Domain',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [{ source: 'OwnerID', rename: 'Owner Id' }],
  },
  {
    key: 'cloud-data-permissions-summary',
    name: 'Cloud Data Permissions Summary',
    [columnTypes.default.key]: [
      {
        source: 'FileName',
        rename: 'File Name',
        type: types.text,
      },
      {
        source: 'Directory',
        rename: 'Directory',
        type: types.text,
      },
      {
        source: 'DirectUsers',
        rename: 'Direct Users',
        type: types.number,
      },
      {
        source: 'TotalUsers',
        rename: 'Total Users',
        type: types.number,
      },
      {
        source: 'TotalGroups',
        rename: 'Total Groups',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [],
    [columnTypes.hidden.key]: [
      {
        source: 'FullAccessPath',
        rename: 'Full Access Path',
        type: types.text,
      },
    ],
  },
  {
    key: 'cloud-data-direct-users',
    name: 'Cloud Data Direct Users',
    [columnTypes.default.key]: [
      {
        source: 'FileName',
        rename: 'File Name',
        type: types.text,
      },
      {
        source: 'Directory',
        rename: 'Directory',
        type: types.text,
      },
      {
        source: 'Account',
        rename: 'Account',
        type: types.text,
      },
      {
        source: 'Domain',
        rename: 'Domain',
        type: types.text,
      },
      {
        source: 'Permission',
        rename: 'Permission',
        type: types.text,
      },
      {
        source: 'AccessType',
        rename: 'Access Type',
        type: types.text,
      },
      {
        source: 'GroupName',
        rename: 'Group Name',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'FullAccessPath',
        rename: 'Full Access Path',
        type: types.text,
      },
      {
        source: 'EntityType',
        rename: 'Entity Type',
        type: types.number,
      },
      {
        source: 'IsDirectUser',
        rename: 'Is Direct User',
        type: types.text,
      },
      {
        source: 'OpenAccess',
        rename: 'Open Access',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'UniqueID',
        rename: 'Id',
        type: types.number,
      },
      {
        source: 'Id_Full_Folder_List',
        rename: 'Id Full Folder List',
        type: types.number,
      },
    ],
  },
  {
    key: 'cloud-data-all-users',
    name: 'Cloud Data All Users',
    [columnTypes.default.key]: [
      {
        source: 'FileName',
        rename: 'File Name',
        type: types.text,
      },
      {
        source: 'Directory',
        rename: 'Directory',
        type: types.text,
      },
      {
        source: 'Account',
        rename: 'Account',
        type: types.text,
      },
      {
        source: 'Domain',
        rename: 'Domain',
        type: types.text,
      },
      {
        source: 'Permission',
        rename: 'Permission',
        type: types.text,
      },
      {
        source: 'AccessType',
        rename: 'Access Type',
        type: types.text,
      },
      {
        source: 'GroupName',
        rename: 'Group Name',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'FullAccessPath',
        rename: 'Full Access Path',
        type: types.text,
      },
      {
        source: 'EntityType',
        rename: 'Entity Type',
        type: types.number,
      },
      {
        source: 'IsDirectUser',
        rename: 'Is Direct User',
        type: types.text,
      },
      {
        source: 'OpenAccess',
        rename: 'Open Access',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'UniqueID',
        rename: 'Id',
        type: types.number,
      },
      {
        source: 'Id_Full_Folder_List',
        rename: 'Id Full Folder List',
        type: types.number,
      },
    ],
  },
  {
    key: 'cloud-data-groups',
    name: 'Cloud Data Groups',
    [columnTypes.default.key]: [
      {
        source: 'FileName',
        rename: 'File Name',
        type: types.text,
      },
      {
        source: 'Directory',
        rename: 'Directory',
        type: types.text,
      },
      {
        source: 'Account',
        rename: 'Account',
        type: types.text,
      },
      {
        source: 'Domain',
        rename: 'Domain',
        type: types.text,
      },
      {
        source: 'Permission',
        rename: 'Permission',
        type: types.text,
      },
      {
        source: 'AccessType',
        rename: 'Access Type',
        type: types.text,
      },
      {
        source: 'GroupName',
        rename: 'Group Name',
        type: types.text,
      },
    ],
    [columnTypes.extra.key]: [
      {
        source: 'FullAccessPath',
        rename: 'Full Access Path',
        type: types.text,
      },
      {
        source: 'EntityType',
        rename: 'Entity Type',
        type: types.number,
      },
      {
        source: 'IsDirectUser',
        rename: 'Is Direct User',
        type: types.text,
      },
      {
        source: 'OpenAccess',
        rename: 'Open Access',
        type: types.text,
      },
    ],
    [columnTypes.hidden.key]: [
      {
        source: 'UniqueID',
        rename: 'Id',
        type: types.number,
      },
      {
        source: 'Id_Full_Folder_List',
        rename: 'Id Full Folder List',
        type: types.number,
      },
    ],
  },
  {
    key: 'cdm-Ext-Int-SharedObjects',
    name: 'cdm Ext Int SharedObjects',
    [columnTypes.default.key]: [
      {
        source: 'BusinessUnit',
        rename: 'Business Unit',
        type: types.text,
      },
      {
        source: 'TotalOpenObjects',
        rename: 'Total Open Objects',
        type: types.number,
      },
      {
        source: 'Sites',
        rename: 'SharePoint Site',
        type: types.number,
      },
      {
        source: 'Teams',
        rename: 'Teams',
        type: types.number,
      },
      {
        source: 'OneDrives',
        rename: 'OneDrive',
        type: types.number,
      },
      {
        source: 'ExternallyShared',
        rename: 'Open External',
        type: types.number,
      },
      {
        source: 'InternallyShared',
        rename: 'Open Internal',
        type: types.number,
      },
    ],
    [columnTypes.extra.key]: [],
    [columnTypes.hidden.key]: [{ source: 'BUID', rename: 'BUID' }],
  },
];

export default [...cloudOwnersTables];
